/* svnty-gallery-swipe.js — THE AXIS LOCK (R133, D3-12c, 2026-09-20). the reference's carousel is Swiper: the first
 * millimetres of a touch decide the axis, and a sideways gesture moves ONLY the carousel, one full slide per swipe.
 * Native scroll-snap lets a diagonal thumb move the page and the carousel together, which reads as dragging the
 * picture around (iPhone 04:12). Here: on touchstart the axis is undecided; once |dx| > |dy| and > 6 px the
 * gesture is the carousel's — the move is prevented and the list is scrolled by hand (snap off during the drag);
 * on release the list glides to the nearest slide, or to the next one if the swipe was fast. A vertical start is
 * never touched: the page scrolls and the carousel stays put. Mouse and keyboard keep Trade's own behaviour. */
(function () {
  'use strict';
  var lists = document.querySelectorAll('.product__media-wrapper .product__media-list.slider--mobile');
  if (!lists.length) return;
  function mq() { return window.matchMedia('(max-width: 749px)').matches; }
  Array.prototype.forEach.call(lists, function (list) {
    var x0 = 0, y0 = 0, sl0 = 0, t0 = 0, axis = null, lastX = 0, lastT = 0, vx = 0;
    function slideW() { var s = list.querySelector('.product__media-item:not(.svnty-colour-hidden)'); return s ? s.getBoundingClientRect().width : list.clientWidth; }
    list.addEventListener('touchstart', function (e) {
      if (!mq() || e.touches.length !== 1) return;
      axis = null; x0 = lastX = e.touches[0].clientX; y0 = e.touches[0].clientY; sl0 = list.scrollLeft; t0 = lastT = e.timeStamp; vx = 0;
    }, { passive: true });
    list.addEventListener('touchmove', function (e) {
      if (!mq() || e.touches.length !== 1) return;
      var x = e.touches[0].clientX, y = e.touches[0].clientY, dx = x - x0, dy = y - y0;
      if (axis === null) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (axis === 'x') { list.style.scrollSnapType = 'none'; list.style.scrollBehavior = 'auto'; }
      }
      if (axis !== 'x') return;
      if (e.cancelable) e.preventDefault();
      var dt = e.timeStamp - lastT; if (dt > 0) vx = (x - lastX) / dt; lastX = x; lastT = e.timeStamp;
      list.scrollLeft = sl0 - dx;
    }, { passive: false });
    function end() {
      if (axis !== 'x') { axis = null; return; }
      axis = null;
      var w = slideW() || 1, cur = list.scrollLeft, from = Math.round(sl0 / w), to = Math.round(cur / w);
      var moved = cur - sl0;
      if (to === from && Math.abs(moved) > w * 0.12) to = from + (moved > 0 ? 1 : -1);
      if (Math.abs(vx) > 0.5 && to === from) to = from + (vx < 0 ? 1 : -1);
      var max = Math.round((list.scrollWidth - list.clientWidth) / w);
      to = Math.max(0, Math.min(max, to));
      list.style.scrollBehavior = '';
      list.scrollTo({ left: to * w, behavior: 'smooth' });
      setTimeout(function () { list.style.scrollSnapType = ''; }, 400);
    }
    list.addEventListener('touchend', end, { passive: true });
    list.addEventListener('touchcancel', end, { passive: true });
  });
})();
